<template>
    <div id="issues-list" :class="['h-100', locationType == 'viewer' && 'inside-viewer']">
        <div class="header">
            <div class="grid">
                <div class="search-input">
                    <div class="icon d-flex justify-content-center align-items-center">
                        <icon name="search" color="var(--secondary-3)" scale=".5" />
                    </div>
                    <input v-model="searchText" type="text" :placeholder="$t('keyword167')" class="w-100" />
                </div>
                <div class="header-btn-container" @click="selectedHeaderOption == 'filter' ? (selectedHeaderOption = '') : (selectedHeaderOption = 'filter')">
                    <div
                        class="header-btn"
                        :class="{ 'header-btn-active': selectedHeaderOption == 'filter', enabled: theresAFilterActive }"
                        v-b-tooltip.hover
                        :title="$t('button_text24')"
                    >
                        <icon name="filter" color="white" scale="0.75" />
                    </div>
                </div>

                <div class="header-btn-container" @click="selectedHeaderOption == 'sort-by' ? (selectedHeaderOption = '') : (selectedHeaderOption = 'sort-by')">
                    <div
                        class="header-btn"
                        :class="{ 'header-btn-active': selectedHeaderOption == 'sort-by', enabled: true }"
                        v-b-tooltip.hover
                        :title="$t('keyword123')"
                    >
                        <icon name="sort-amount-down" color="white" scale="0.75" />
                    </div>
                </div>

                <div
                    class="header-btn-container"
                    @click="selectedHeaderOption == 'group-by' ? (selectedHeaderOption = '') : (selectedHeaderOption = 'group-by')"
                >
                    <div
                        class="header-btn"
                        :class="{ 'header-btn-active': selectedHeaderOption == 'group-by', enabled: isGroupingBy }"
                        v-b-tooltip.hover
                        :title="$t('keyword189')"
                    >
                        <icon name="ci-group-by" color="white" scale="0.75" />
                    </div>
                </div>
            </div>
            <div ref="warnings-element" class="warnings" v-show="theresAFilterActive">
                <p class="text-12 text-secondary-3">
                    {{ $t('Views_Viewer_Sidebar_Issues_List_1') }}
                    <span @click="resetGeneralFilters" class="cursor-pointer text-secondary text-decoration-underline-hover">{{
                        $t('Views_Viewer_Sidebar_Issues_List_2')
                    }}</span>
                </p>
            </div>
        </div>
        <div ref="list-element" class="list d-flex">
            <!-- FILTER -->
            <div class="filters-box general-filters h-100" v-show="selectedHeaderOption == 'filter'">
                <div class="filters-box-body">
                    <!-- Responsibles -->
                    <ci-multiple-select2 class="mb-3" :label="$t('keyword82') + ':'" :options="responsiblesOptions" v-model="selectedResponsibles" />

                    <!-- Created by -->
                    <ci-multiple-select2 class="mb-3" :label="'Criado por:'" :options="createdByOptions" v-model="selectedCreatedBy" />

                    <!-- Subjects -->
                    <ci-multiple-select2 class="mb-3" :label="$t('keyword122') + ':'" :options="subjectsOptions" v-model="selectedSubjects" />

                    <!-- Location -->
                    <ci-multiple-select2
                        v-if="locationType != 'viewer'"
                        class="mb-3"
                        :label="$t('keyword80') + ':'"
                        :options="locationsOptions"
                        v-model="selectedLocations"
                    />

                    <!-- Types -->
                    <ci-multiple-select2 class="mb-3" :label="$t('type.singular')" :options="typesOptions" disableBranchNodes v-model="selectedTypes" />

                    <!-- Causes -->
                    <ci-multiple-select2 class="mb-2" :label="$t('cause.singular')" :options="causesOptions" disableBranchNodes v-model="selectedCauses" />

                    <!-- Due dates range -->
                    <div class="d-flex mb-2 dates-container">
                        <ci-date-input :label="$t('deadline') + ' (' + $t('keyword26') + ')'" v-model="dueDates.init" class="mr-2" />
                        <ci-date-input :label="$t('deadline') + ' (' + $t('keyword91') + ')'" v-model="dueDates.end" class="ml-2" />
                    </div>

                    <!-- Created at dates range -->
                    <div class="d-flex dates-container mb-2">
                        <ci-date-input
                            :label="$t('Components_Viewer_UI_Mobile_IssueView_4') + ' (' + $t('keyword26') + ')'"
                            v-model="createDates.init"
                            class="mr-2"
                        />
                        <ci-date-input
                            :label="$t('Components_Viewer_UI_Mobile_IssueView_4') + ' (' + $t('keyword91') + ')'"
                            v-model="createDates.end"
                            class="ml-2"
                        />
                    </div>

                    <!-- Closed at dates range -->
                    <div class="d-flex dates-container mb-2">
                        <ci-date-input :label="$t('keyword190') + ' (' + $t('keyword26') + ')'" v-model="finishDates.init" class="mr-2" />
                        <ci-date-input :label="$t('keyword190') + ' (' + $t('keyword91') + ')'" v-model="finishDates.end" class="ml-2" />
                    </div>

                    <p class="text-12 text-secondary-3 mb-1">
                        {{ $t('keyword55') }}
                    </p>
                    <div class="priority-filters">
                        <div @click="togglePriority('high')" class="priority-btn high" :class="{ active: selectedPriorities.includes('high') }">
                            <p class="text-12">{{ $t('high') }}</p>
                        </div>
                        <div @click="togglePriority('medium')" class="priority-btn medium" :class="{ active: selectedPriorities.includes('medium') }">
                            <p class="text-12">{{ $t('medium') }}</p>
                        </div>
                        <div @click="togglePriority('low')" class="priority-btn low" :class="{ active: selectedPriorities.includes('low') }">
                            <p class="text-12">{{ $t('low') }}</p>
                        </div>
                    </div>
                </div>
                <div class="filters-box-footer">
                    <div class="reset-btn d-flex justify-content-center align-items-center" @click="resetGeneralFilters">
                        <p :class="['text-10 text-secondary', !theresAComplexFilterActive && 'text-secondary-3']">
                            {{ $t('button_text23') }}
                        </p>
                    </div>
                    <div class="action-btn d-flex justify-content-center align-items-center" @click="generateFilterOptions">
                        <p class="text-10 text-secondary">{{ $t('button_text24') }}</p>
                    </div>
                </div>
            </div>

            <!-- SORT BY -->
            <div class="filters-box" v-show="selectedHeaderOption == 'sort-by'">
                <div class="filters-box-body">
                    <div class="d-flex flex-column">
                        <p class="text-16 mb-2 text-secondary-3">
                            {{ $t('keyword123') }}
                        </p>
                        <b-form-radio
                            v-for="orderByOption in orderByOptions"
                            :key="orderByOption.id"
                            v-model="orderByFilter"
                            name="order-by-radios"
                            :value="orderByOption.id"
                            >{{ orderByOption.text }}
                        </b-form-radio>

                        <p class="text-16 mt-3 mb-2 text-secondary-3">
                            {{ $t('keyword191') }}
                        </p>
                        <div class="d-flex">
                            <b-form-radio class="mr-3" v-model="sortByFilter" name="sort-by-radios" value="asc">{{ $t('keyword192') }} </b-form-radio>
                            <b-form-radio v-model="sortByFilter" name="sort-by-radios" value="desc">{{ $t('keyword193') }} </b-form-radio>
                        </div>
                    </div>
                </div>
                <div class="filters-box-footer">
                    <div class="reset-btn d-flex justify-content-center align-items-center" @click="resetOrderByFilter">
                        <p class="text-10 text-secondary">{{ $t('button_text23') }}</p>
                    </div>
                    <div class="action-btn d-flex justify-content-center align-items-center" @click="generateOrder">
                        <p class="text-10 text-secondary">{{ $t('keyword194') }}</p>
                    </div>
                </div>
            </div>

            <!-- GROUP BY -->
            <div class="filters-box" v-show="selectedHeaderOption == 'group-by'">
                <div class="filters-box-body">
                    <div class="d-flex flex-column">
                        <p class="text-16 mb-3 text-secondary-3">
                            {{ $t('Views_Projects_Analytics_Dashboard_10') }}
                        </p>
                        <b-form-radio
                            v-for="groupByOption in groupByOptions"
                            :key="groupByOption.id"
                            v-model="groupByFilter"
                            name="group-by-radios"
                            :value="groupByOption.id"
                            >{{ groupByOption.label }}
                        </b-form-radio>
                        <div class="mt-3" v-if="groupByFilter == 1 && project.map">
                            <p class="text-16 mb-3 text-secondary-3">{{ $t('Components_Issues_IssueList_3') }}:</p>
                            <b-form-radio v-model="groupByLocationType" name="location-type-radios" value="0"
                                >{{ $t('Components_Issues_IssueList_5') }}
                            </b-form-radio>
                            <b-form-radio v-model="groupByLocationType" name="location-type-radios" value="1"
                                >{{ $t('Components_Issues_IssueList_4') }}
                            </b-form-radio>
                        </div>
                    </div>
                </div>
            </div>

            <vue-custom-scrollbar v-show="!isFilterBoxOpen" infinite-wrapper :settings="scrollbarOptions" class="list-issues-scroll-container">
                <div v-if="issues.length">
                    <template v-if="groupByFilter == -1">
                        <template v-for="(issue, index) in issues">
                            <Issue
                                :status="status"
                                @click="$emit('issueClick', issue)"
                                :key="index"
                                :issue="issue"
                                :isSelected="issue.id == selectedIssue.id"
                                :locationType="locationType"
                            />
                            <div :key="'separator-' + index" class="item-separator">
                                <div class="bar" v-if="issue.id != selectedIssue.id && issues[index + 1] && issues[index + 1].id != selectedIssue.id"></div>
                            </div>
                        </template>
                    </template>

                    <!-- Due date -->
                    <div class="group-by-container" v-if="groupByFilter == 0">
                        <div class="collapse-container" v-if="overduedIssues.length">
                            <div class="header" @click="groupByCollapseController.dueDate.overdue = !groupByCollapseController.dueDate.overdue">
                                <div class="header-body">
                                    <icon
                                        color="var(--secondary-3)"
                                        name="sort-down"
                                        scale=".9"
                                        :style="`transform: rotate(${!groupByCollapseController.dueDate.overdue ? -90 : 0}deg); transition: transform .3s;`"
                                    />

                                    <p class="text-16">
                                        {{ $t('keyword195') }}
                                    </p>
                                </div>
                            </div>
                            <b-collapse v-model="groupByCollapseController.dueDate.overdue" class="content">
                                <template v-for="(issue, index) in overduedIssues">
                                    <Issue
                                        :status="status"
                                        @click="$emit('issueClick', issue)"
                                        :key="index"
                                        :issue="issue"
                                        :isSelected="issue.id == selectedIssue.id"
                                        :locationType="locationType"
                                    />
                                    <div :key="'separator-' + index" class="item-separator">
                                        <div
                                            class="bar"
                                            v-if="issue.id != selectedIssue.id && overduedIssues[index + 1] && overduedIssues[index + 1].id != selectedIssue.id"
                                        ></div>
                                    </div>
                                </template>
                            </b-collapse>
                        </div>

                        <div class="collapse-container" v-if="thisWeekIssuess.length">
                            <div class="header" @click="groupByCollapseController.dueDate.thisWeek = !groupByCollapseController.dueDate.thisWeek">
                                <div class="header-body">
                                    <icon
                                        color="var(--secondary-3)"
                                        name="sort-down"
                                        scale=".9"
                                        :style="`transform: rotate(${!groupByCollapseController.dueDate.thisWeek ? -90 : 0}deg); transition: transform .3s;`"
                                    />

                                    <p class="text-16">
                                        {{ $t('Components_Issues_IssueList_6') }}
                                    </p>
                                </div>
                            </div>
                            <b-collapse v-model="groupByCollapseController.dueDate.thisWeek" class="content">
                                <template v-for="(issue, index) in thisWeekIssuess">
                                    <Issue
                                        :status="status"
                                        @click="$emit('issueClick', issue)"
                                        :key="index"
                                        :issue="issue"
                                        :isSelected="issue.id == selectedIssue.id"
                                        :locationType="locationType"
                                    />
                                    <div :key="'separator-' + index" class="item-separator">
                                        <div
                                            class="bar"
                                            v-if="
                                                issue.id != selectedIssue.id && thisWeekIssuess[index + 1] && thisWeekIssuess[index + 1].id != selectedIssue.id
                                            "
                                        ></div>
                                    </div>
                                </template>
                            </b-collapse>
                        </div>

                        <div class="collapse-container" v-if="next30DaysIssues.length">
                            <div class="header" @click="groupByCollapseController.dueDate.next30Days = !groupByCollapseController.dueDate.next30Days">
                                <div class="header-body">
                                    <icon
                                        color="var(--secondary-3)"
                                        name="sort-down"
                                        scale=".9"
                                        :style="`transform: rotate(${!groupByCollapseController.dueDate.next30Days ? -90 : 0}deg); transition: transform .3s;`"
                                    />

                                    <p class="text-16">
                                        {{ $t('Components_Issues_IssueList_7') }}
                                    </p>
                                </div>
                            </div>
                            <b-collapse v-model="groupByCollapseController.dueDate.next30Days" class="content">
                                <template v-for="(issue, index) in next30DaysIssues">
                                    <Issue
                                        :status="status"
                                        @click="$emit('issueClick', issue)"
                                        :key="index"
                                        :issue="issue"
                                        :isSelected="issue.id == selectedIssue.id"
                                        :locationType="locationType"
                                    />
                                    <div :key="'separator-' + index" class="item-separator">
                                        <div
                                            class="bar"
                                            v-if="
                                                issue.id != selectedIssue.id &&
                                                next30DaysIssues[index + 1] &&
                                                next30DaysIssues[index + 1].id != selectedIssue.id
                                            "
                                        ></div>
                                    </div>
                                </template>
                            </b-collapse>
                        </div>

                        <div class="collapse-container" v-if="after30DaysIssues.length">
                            <div class="header" @click="groupByCollapseController.dueDate.after30Days = !groupByCollapseController.dueDate.after30Days">
                                <div class="header-body">
                                    <icon
                                        color="var(--secondary-3)"
                                        name="sort-down"
                                        scale=".9"
                                        :style="`transform: rotate(${!groupByCollapseController.dueDate.after30Days ? -90 : 0}deg); transition: transform .3s;`"
                                    />

                                    <p class="text-16">
                                        {{ $t('Components_Issues_IssueList_8') }}
                                    </p>
                                </div>
                            </div>
                            <b-collapse v-model="groupByCollapseController.dueDate.after30Days" class="content">
                                <template v-for="(issue, index) in after30DaysIssues">
                                    <Issue
                                        :status="status"
                                        @click="$emit('issueClick', issue)"
                                        :key="index"
                                        :issue="issue"
                                        :isSelected="issue.id == selectedIssue.id"
                                        :locationType="locationType"
                                    />
                                    <div :key="'separator-' + index" class="item-separator">
                                        <div
                                            class="bar"
                                            v-if="
                                                issue.id != selectedIssue.id &&
                                                after30DaysIssues[index + 1] &&
                                                after30DaysIssues[index + 1].id != selectedIssue.id
                                            "
                                        ></div>
                                    </div>
                                </template>
                            </b-collapse>
                        </div>

                        <div class="collapse-container" v-if="issuesWithoutDueDate.length">
                            <div class="header" @click="groupByCollapseController.dueDate.noDueDate = !groupByCollapseController.dueDate.noDueDate">
                                <div class="header-body">
                                    <icon
                                        color="var(--secondary-3)"
                                        name="sort-down"
                                        scale=".9"
                                        :style="`transform: rotate(${!groupByCollapseController.dueDate.noDueDate ? -90 : 0}deg); transition: transform .3s;`"
                                    />

                                    <p class="text-16">
                                        {{ $t('Components_Issues_IssueList_9') }}
                                    </p>
                                </div>
                            </div>
                            <b-collapse v-model="groupByCollapseController.dueDate.noDueDate" class="content">
                                <template v-for="(issue, index) in issuesWithoutDueDate">
                                    <Issue
                                        :status="status"
                                        @click="$emit('issueClick', issue)"
                                        :key="index"
                                        :issue="issue"
                                        :isSelected="issue.id == selectedIssue.id"
                                        :locationType="locationType"
                                    />
                                    <div :key="'separator-' + index" class="item-separator">
                                        <div
                                            class="bar"
                                            v-if="
                                                issue.id != selectedIssue.id &&
                                                issuesWithoutDueDate[index + 1] &&
                                                issuesWithoutDueDate[index + 1].id != selectedIssue.id
                                            "
                                        ></div>
                                    </div>
                                </template>
                            </b-collapse>
                        </div>
                    </div>

                    <!-- Location -->
                    <div class="group-by-container" v-if="groupByFilter == 1">
                        <div class="collapse-container" v-for="(location, index) in groupByCollapseController.locations" :key="location.id">
                            <div class="header" @click="groupByCollapseController.locations[index].isOpen = !groupByCollapseController.locations[index].isOpen">
                                <div class="header-body">
                                    <icon
                                        color="var(--secondary-3)"
                                        name="sort-down"
                                        scale=".9"
                                        :style="`transform: rotate(${
                                            !groupByCollapseController.locations[index].isOpen ? -90 : 0
                                        }deg); transition: transform .3s;`"
                                    />

                                    <p class="text-16">
                                        {{ location.label }}
                                    </p>
                                </div>
                            </div>
                            <b-collapse v-model="groupByCollapseController.locations[index].isOpen" class="content">
                                <template v-for="(issue, index) in location.issues">
                                    <Issue
                                        :status="status"
                                        @click="$emit('issueClick', issue)"
                                        :key="index"
                                        :issue="issue"
                                        :isSelected="issue.id == selectedIssue.id"
                                        :locationType="locationType"
                                    />
                                    <div :key="'separator-' + index" class="item-separator">
                                        <div
                                            class="bar"
                                            v-if="
                                                issue.id != selectedIssue.id && location.issues[index + 1] && location.issues[index + 1].id != selectedIssue.id
                                            "
                                        ></div>
                                    </div>
                                </template>
                            </b-collapse>
                        </div>
                    </div>

                    <!-- Type -->
                    <div class="group-by-container" v-if="groupByFilter == 2">
                        <div class="collapse-container" v-for="(type, index) in groupByCollapseController.types" :key="type.id">
                            <div class="header" @click="groupByCollapseController.types[index].isOpen = !groupByCollapseController.types[index].isOpen">
                                <div class="header-body">
                                    <icon
                                        color="var(--secondary-3)"
                                        name="sort-down"
                                        scale=".9"
                                        :style="`transform: rotate(${!groupByCollapseController.types[index].isOpen ? -90 : 0}deg); transition: transform .3s;`"
                                    />

                                    <p class="text-16">
                                        {{ type.label }}
                                    </p>
                                </div>
                            </div>
                            <b-collapse v-model="groupByCollapseController.types[index].isOpen" class="content">
                                <template v-for="(issue, index) in type.issues">
                                    <Issue
                                        :status="status"
                                        @click="$emit('issueClick', issue)"
                                        :key="index"
                                        :issue="issue"
                                        :isSelected="issue.id == selectedIssue.id"
                                        :locationType="locationType"
                                    />
                                    <div :key="'separator-' + index" class="item-separator">
                                        <div
                                            class="bar"
                                            v-if="issue.id != selectedIssue.id && type.issues[index + 1] && type.issues[index + 1].id != selectedIssue.id"
                                        ></div>
                                    </div>
                                </template>
                            </b-collapse>
                        </div>
                    </div>

                    <!-- Cause -->
                    <div class="group-by-container" v-if="groupByFilter == 3">
                        <div class="collapse-container" v-for="(cause, index) in groupByCollapseController.causes" :key="cause.id">
                            <div class="header" @click="groupByCollapseController.causes[index].isOpen = !groupByCollapseController.causes[index].isOpen">
                                <div class="header-body">
                                    <icon
                                        color="var(--secondary-3)"
                                        name="sort-down"
                                        scale=".9"
                                        :style="`transform: rotate(${
                                            !groupByCollapseController.causes[index].isOpen ? -90 : 0
                                        }deg); transition: transform .3s;`"
                                    />

                                    <p class="text-16">
                                        {{ cause.label }}
                                    </p>
                                </div>
                            </div>
                            <b-collapse v-model="groupByCollapseController.causes[index].isOpen" class="content">
                                <template v-for="(issue, index) in cause.issues">
                                    <Issue
                                        :status="status"
                                        @click="$emit('issueClick', issue)"
                                        :key="index"
                                        :issue="issue"
                                        :isSelected="issue.id == selectedIssue.id"
                                        :locationType="locationType"
                                    />
                                    <div :key="'separator-' + index" class="item-separator">
                                        <div
                                            class="bar"
                                            v-if="issue.id != selectedIssue.id && cause.issues[index + 1] && cause.issues[index + 1].id != selectedIssue.id"
                                        ></div>
                                    </div>
                                </template>
                            </b-collapse>
                        </div>
                    </div>
                </div>

                <div v-else-if="!isLoading" class="h-100 d-flex justify-content-center align-items-center">
                    <div v-if="!theresAFilterActive" class="d-flex justify-content-center flex-column">
                        <p class="text-12 text-weight-bold text-secondary-3">{{ $t('Components_Issues_IssueList_2') }}</p>
                    </div>
                    <div v-else class="d-flex justify-content-center flex-column p-3">
                        <p class="text-12 text-weight-bold text-secondary-3 mb-2">{{ $t('Components_Issues_IssueList_1') }}</p>
                        <ci-button
                            @click="
                                resetFilters()
                                generateFilterOptions()
                            "
                            normalCase
                            :text="$t('keyword22')"
                        />
                    </div>
                </div>

                <!-- <infinite-loading v-if="issues.length" forceUseInfiniteWrapper :identifier="infiniteId" @infinite="nextPage">
    <div slot="spinner">
        <div class="my-1">
            <b-spinner small label="Loading"></b-spinner>
        </div>
    </div>
    <div slot="no-more" class="text-12 text-weight-bold my-2 text-gray">{{ $t('keyword92') }}</div>
    <div slot="no-results"></div>
</infinite-loading> -->
                <div v-else-if="isLoading" class="my-1 w-100 d-flex justify-content-center align-items-center">
                    <b-spinner small label="Loading"></b-spinner>
                </div>
            </vue-custom-scrollbar>
        </div>
    </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'
import Issue from '@/components/Issues/IssueItem'
import debounce from 'debounce'
import _ from 'lodash'

import 'vue-awesome/icons/search'
import 'vue-awesome/icons/sort-amount-down'
import 'vue-awesome/icons/sort-down'

// Queries
// ==============
// JSON data
// ==============
import getProjectLocation from '@/data/getProjectLocation'
import getIssueFilterOptions from '@/data/getIssueFilterOptions'

import moment from 'moment'

/**
 * Summary.
 * Use this component to mount a CIN issues list.
 *
 * @param {Array} issues - Array of issues
 * @param {Object} selectedIssue - Selected issue object
 * @param {Boolean} isLoading - Determines if is loading
 * @param {String} locationType - viewer/normal
 * @param {Object} issueInfoOptions - (types, causes and subjects)
 * @param {Object} project - project
 * @event issueClick - On issue item click.
 *
 *
 *
 */

export default {
    components: {
        VueCustomScrollbar,
        Issue,
    },
    props: {
        selectedIssue: {
            type: Object,
            default: () => {
                return {}
            },
        },

        status: {
            type: String,
        },
        locationType: String,
        // issueInfoOptions: Object,
        project: Object,
        locationFilterFloorplanId: Number,
    },
    watch: {
        searchText() {
            clearTimeout(this.searchTimeout)

            this.searchTimeout = setTimeout(() => {
                // this.generateFilterOptions()
                this.getIssues()
            }, 500)
        },
        status(after, before) {
            if (this.filterReseted) {
                this.filterReseted = false
                this.issueFilter = undefined
            }
            // this.generateFilterOptions()
            this.getIssues(after)
        },
        groupByFilter() {
            this.selectedHeaderOption = null
            // this.generateFilterOptions()
            // alert()
        },
        issues() {
            // TYPES
            this.setupTypeCollapse()

            // CAUSES
            this.setupCauseCollapse()

            // LOCATION
            this.setupLocationCollapse()
        },
        groupByLocationType() {
            this.setupLocationCollapse()
        },
        // watch for height changes in list
        issueFilter: {
            handler() {
                this.handleListHeightChange()
            },
            deep: true,
        },
    },
    computed: {
        /**
         * Summary.
         * verify if there is some active filter. (Viewer)
         *
         * @returns {Boolean}
         */
        theresAFilterActive: function () {
            return (
                this.issueFilter &&
                (this.issueFilter.closed_end ||
                    this.issueFilter.closed_start ||
                    this.issueFilter.created_end ||
                    this.issueFilter.created_start ||
                    this.issueFilter.due_date_end ||
                    this.issueFilter.due_date_start ||
                    this.issueFilter.priorities.length ||
                    this.issueFilter.responsibles.length ||
                    this.issueFilter.created_by.length ||
                    (this.locationType != 'viewer' && this.issueFilter.locations.length) ||
                    this.issueFilter.subjects.length ||
                    this.issueFilter.types.length ||
                    this.issueFilter.causes.length)
            )
        },

        theresAComplexFilterActive() {
            return (
                this.selectedResponsibles.length ||
                this.selectedCreatedBy.length ||
                this.selectedLocations.length ||
                this.selectedPriorities.length ||
                this.selectedLocations.length ||
                this.selectedSubjects.length ||
                this.selectedCauses.length ||
                this.selectedTypes.length ||
                this.createDates.init ||
                this.createDates.end ||
                this.finishDates.init ||
                this.finishDates.end ||
                this.dueDates.init ||
                this.dueDates.end
            )
        },

        isGroupingBy() {
            return this.groupByFilter != -1
        },

        groupByField() {
            switch (this.groupByFilter) {
                case 0:
                    return 'due_date'
                case 1:
                    return 'location'
                case 2:
                    return 'type'
                case 3:
                    return 'cause'
                default:
                    return null
            }
        },

        orderingBy() {
            return this.orderByOptions[this.orderByFilter].text
        },

        // ==================
        // GROUP BY: DUEDATE. COMPUTED RESULTS
        // ==================
        overduedIssues() {
            return this.issues.filter((issue) => {
                if (!issue.due_date) {
                    return false
                }
                const date = issue.due_date.includes('/') ? issue.due_date : moment(issue.due_date).format('DD/MM/YYYY')
                let daysDiff = moment.duration(this.$moment(date, 'DD/MM/YYYY').diff(this.$moment())).asDays()
                return daysDiff < 0
            })
        },
        thisWeekIssuess() {
            return this.issues.filter((issue) => {
                if (!issue.due_date) {
                    return false
                }
                const date = issue.due_date.includes('/') ? issue.due_date : moment(issue.due_date).format('DD/MM/YYYY')
                let daysDiff = moment.duration(this.$moment(date, 'DD/MM/YYYY').diff(this.$moment())).asDays()
                return daysDiff >= 0 && daysDiff <= 7
            })
        },
        next30DaysIssues() {
            return this.issues.filter((issue) => {
                if (!issue.due_date) {
                    return false
                }

                const date = issue.due_date.includes('/') ? issue.due_date : moment(issue.due_date).format('DD/MM/YYYY')
                let daysDiff = moment.duration(this.$moment(date, 'DD/MM/YYYY').diff(this.$moment())).asDays()
                return daysDiff >= 0 && daysDiff <= 30
            })
        },
        after30DaysIssues() {
            return this.issues.filter((issue) => {
                if (!issue.due_date) {
                    return false
                }

                const date = issue.due_date.includes('/') ? issue.due_date : moment(issue.due_date).format('DD/MM/YYYY')
                let daysDiff = moment.duration(this.$moment(date, 'DD/MM/YYYY').diff(this.$moment())).asDays()
                return daysDiff > 30
            })
        },
        issuesWithoutDueDate() {
            return this.issues.filter((issue) => !issue.due_date)
        },
    },
    data() {
        return {
            // ================
            // Data of JSON
            // ================
            getProjectLocation,
            getIssuesData: this.$store.state.demo.getIssues,
            getIssueFilterOptions,
            // =============
            typesOptions: [],
            causesOptions: [],
            subjectsOptions: [],
            locationsOptions: [],
            responsiblesOptions: [],
            createdByOptions: [],
            issueFilterOptions: {},
            floorplans: [],

            infiniteId: +new Date(),
            issues: [],
            limit: 20,
            page: 1,
            isLoading: false,

            issueFilter: null,
            issueOrder: {
                asc: false,
                field: 'created_at',
            },

            // ====================
            // FILTERS
            // ====================
            orderByOptions: [
                {
                    value: 'priority',
                    text: this.$t('keyword55'),
                    id: 0,
                },
                {
                    value: 'created_at',
                    text: this.$t('keyword58'),
                    id: 1,
                },
                {
                    value: 'updated_at',
                    text: this.$t('keyword124'),
                    id: 2,
                },
            ],
            groupByOptions: [
                {
                    id: -1,
                    label: this.$t('Components_Issues_IssueList_10'),
                },
                {
                    id: 0,
                    label: this.$t('Components_Issues_IssueList_11'),
                },
                {
                    id: 1,
                    label: this.$t('Components_Issues_IssueList_12'),
                },
                {
                    id: 2,
                    label: this.$t('Components_Issues_IssueList_13'),
                },
                {
                    id: 3,
                    label: this.$t('Components_Issues_IssueList_14'),
                },
            ],
            orderByFilter: 1, // 0 - Priority, 1 - Created at, 2 - Updated at
            groupByFilter: -1, // -1 - No group, 0 - Due date, 1 - Location, 2 - Type, 3 - Cause
            sortByFilter: 'desc', // asc, desc
            groupByLocationType: 0, // 0 - Floorplans, 1 - Sectors
            filterCreatedBy: [],
            issueOptions: {},

            selectedPriorities: [],
            selectedLocations: [],
            selectedSubjects: [],
            selectedCauses: [],
            selectedTypes: [],
            selectedResponsibles: [],
            selectedCreatedBy: [],
            createDates: {
                init: null,
                end: null,
            },
            finishDates: {
                init: null,
                end: null,
            },
            dueDates: {
                init: null,
                end: null,
            },
            selectedHeaderOption: '',
            searchText: '',
            searchTimeout: null,
            // ====================
            // GROUP BY CONTROLLER
            // ====================
            groupByCollapseController: {
                dueDate: {
                    overdue: true,
                    thisWeek: true,
                    next30Days: true,
                    after30Days: true,
                    noDueDate: true,
                },
                types: [],
                locations: [],
                causes: [],
            },

            // ====================
            // FLAGS
            // ====================
            isFilterDropdownOpen: false,
            isFilterBoxOpen: false,

            // ====================
            // OTHERS
            // ====================
            scrollbarOptions: {
                suppressScrollX: true,
            },
            infiniteScrollState: null,
            statusUniversal: 'open',
            filterReseted: false,
            filterControl: [],
        }
    },
    methods: {
        // ==============================
        // New methods, JSON local
        // ==============================
        filterBySubjects() {
            if (this.issueFilter.subjects.length > 0) {
                let aux = []
                this.issueFilter.subjects.forEach((sub) => {
                    this.issues.forEach((issue) => {
                        if (issue.subjects.includes(sub)) {
                            let exists = aux.find((_) => _.id == issue.id)
                            if (!exists) aux.push(issue)
                        }
                    })
                })
                return aux
            }
            return []
        },
        filterByResponsibles() {
            if (this.issueFilter.responsibles.length > 0) {
                let aux = []
                this.issueFilter.responsibles.forEach((res) => {
                    this.issues.forEach((issue) => {
                        issue.tags.forEach((tag) => {
                            tag.members.forEach((member) => {
                                if (member.id == res) {
                                    let exists = aux.find((_) => _.id == issue.id)
                                    if (!exists) aux.push(issue)
                                }
                            })
                        })
                    })
                })
                return aux
            }
            return []
        },
        filterByTypes() {
            if (this.issueFilter.types.length > 0)
                return this.issues.filter((issue) => {
                    return this.issueFilter.types.includes(issue.type != undefined ? issue.type : '')
                })
            return []
        },
        filterByPriorities() {
            if (this.issueFilter.priorities.length > 0)
                return this.issues.filter((issue) => {
                    return this.issueFilter.priorities.includes(issue.priority != undefined ? issue.priority : '')
                })

            return []
        },
        filterByCauses() {
            if (this.issueFilter.causes.length > 0)
                return this.issues.filter((issue) => {
                    return this.issueFilter.causes.includes(issue.cause != undefined ? issue.cause : '')
                })
            return []
        },
        filterByCreatedBy() {
            if (this.issueFilter.created_by.length > 0)
                return this.issues.filter((issue) => {
                    issue.query = 'createdBy'
                    return this.issueFilter.created_by.includes(issue.created_by.id != undefined ? issue.created_by.id : '')
                })
            return []
        },
        filterByDueDate() {
            let dueDateStart = new moment(this.issueFilter.due_date_start)
            let dueDateEnd = new moment(this.issueFilter.due_date_end)

            if (dueDateStart.isValid()) {
                if (dueDateEnd.isValid()) {
                    return this.issues.filter((issue) => {
                        let dateFormated = this.formatedDate(issue.due_date)

                        let dueDate = new moment(dateFormated)

                        if (moment.duration(dueDateStart.diff(dueDate)).asDays() < 0 && moment.duration(dueDateEnd.diff(dueDate)).asDays() > 0) {
                            return { ...issue, query: 'dueDate' }
                        }
                    })
                } else {
                    return this.issues.filter((issue) => {
                        let dateFormated = this.formatedDate(issue.due_date)

                        let dueDate = new moment(dateFormated)
                        if (moment.duration(dueDateStart.diff(dueDate)).asDays() <= 0) {
                            return { ...issue, query: 'dueDate' }
                        }
                    })
                }
            } else if (dueDateEnd.isValid()) {
                return this.issues.filter((issue) => {
                    let dateFormated = this.formatedDate(issue.due_date)

                    let dueDate = new moment(dateFormated)
                    if (moment.duration(dueDateEnd.diff(dueDate)).asDays() >= 0) {
                        return { ...issue, query: 'dueDate' }
                    }
                })
            } else {
                return []
            }
        },
        filterByCreatedAt() {
            let createdAtStart = new moment(this.issueFilter.created_start)
            let createdAtEnd = new moment(this.issueFilter.created_end)

            if (createdAtStart.isValid()) {
                if (createdAtEnd.isValid()) {
                    return this.issues.filter((issue) => {
                        let dateFormated = this.formatedDate(issue.created_at.split(' ')[0])

                        let createdAt = new moment(dateFormated)

                        if (moment.duration(createdAtStart.diff(createdAt)).asDays() < 0 && moment.duration(createdAtEnd.diff(createdAt)).asDays() > 0) {
                            issue.query = 'createdAt'
                            return issue
                        }
                    })
                } else {
                    return this.issues.filter((issue) => {
                        let dateFormated = this.formatedDate(issue.created_at.split(' ')[0])

                        let createdAt = new moment(dateFormated)
                        if (moment.duration(createdAtStart.diff(createdAt)).asDays() <= 0) {
                            issue.query = 'createdAt'

                            return issue
                        }
                    })
                }
            } else if (createdAtEnd.isValid()) {
                return this.issues.filter((issue) => {
                    let dateFormated = this.formatedDate(issue.created_at.split(' ')[0])

                    let createdAt = new moment(dateFormated)
                    if (moment.duration(createdAtEnd.diff(createdAt)).asDays() >= 0) {
                        issue.query = 'createdAt'

                        return issue
                    }
                })
            } else {
                return []
            }
        },
        filterByClosedAt() {
            let closedAtStart = new moment(this.issueFilter.closed_start)
            let closedAtEnd = new moment(this.issueFilter.closed_end)

            if (closedAtStart.isValid()) {
                if (closedAtEnd.isValid()) {
                    return this.issues.filter((issue) => {
                        if (issue.closed_at !== undefined && issue.closed_at !== null) {
                            let dateFormated = this.formatedDate(issue.closed_at)

                            let closedAt = new moment(dateFormated)

                            if (moment.duration(closedAtStart.diff(closedAt)).asDays() < 0 && moment.duration(closedAtEnd.diff(closedAt)).asDays() > 0) {
                                issue.query = 'closedAt'
                                return issue
                            }
                        }
                    })
                } else {
                    return this.issues.filter((issue) => {
                        if (issue.closed_at !== undefined && issue.closed_at !== null) {
                            let dateFormated = this.formatedDate(issue.closed_at)

                            let closedAt = new moment(dateFormated)
                            if (moment.duration(closedAtStart.diff(closedAt)).asDays() <= 0) {
                                issue.query = 'closedAt'

                                return issue
                            }
                        }
                    })
                }
            } else if (closedAtEnd.isValid()) {
                return this.issues.filter((issue) => {
                    if (issue.closed_at !== undefined && issue.closed_at !== null) {
                        let dateFormated = this.formatedDate(issue.closed_at)

                        let closedAt = new moment(dateFormated)
                        if (moment.duration(closedAtEnd.diff(closedAt)).asDays() >= 0) {
                            issue.query = 'closedAt'

                            return issue
                        }
                    }
                })
            } else {
                return []
            }
        },
        setSelectionIssue(auxIssues, data) {
            if ((this.locationType != 'viewer' && auxIssues.length == 0) || (auxIssues[0] && auxIssues[0].id != data.getProject.issues[0].id)) {
                if (this.$route.query && (this.$route.query.issue || this.$route.query.issue_id) && this.$route.query.status == this.status) {
                    this.$emit('setSelectedIssue', Number(this.$route.query.issue || this.$route.query.issue_id))
                } else if (this.issues[0]) {
                    //this.$emit('setSelectedIssue', this.issues[0].id)
                }
            }
        },
        getIssues(status = 'open') {
            const data = this.getIssuesData.data
            let auxIssues = [...this.issues]

            this.issues = data.getProject.issues.filter((issue) => {
                return issue.status == status && issue.text.toUpperCase().includes(this.searchText.toUpperCase())
            })
            this.statusUniversal = status

            if (this.issueFilter != undefined) {
                let issues = [
                    ...this.filterByTypes(),
                    ...this.filterByPriorities(),
                    ...this.filterByPriorities(),
                    ...this.filterByCauses(),
                    ...this.filterByCreatedBy(),
                    ...this.filterBySubjects(),
                    ...this.filterByResponsibles(),
                    ...this.filterByDueDate(),
                    ...this.filterByCreatedAt(),
                    ...this.filterByClosedAt(),
                ]

                this.issues = []

                issues.forEach((issue, index) => {
                    let exists = this.issues.find((_) => _.id == issue.id)
                    if (!exists) this.issues.push(issue)
                })
            }
            this.issues = _.orderBy(this.issues, [this.issueOrder.field], [this.issueOrder.asc])

            this.setSelectionIssue(auxIssues, data)
            this.isLoading = false
            this.$emit('issueCountUpdated', {
                issueCount: this.$store.state.demo.getIssues.data.getProject.issue_count,
                issueFilterCount: this.$store.state.demo.getIssues.data.getProject.issue_filter_results,
            })
        },
        formatedDate(val) {
            if (val !== undefined && val !== null) {
                return val.split('/')[2] + '-' + val.split('/')[1] + '-' + val.split('/')[0]
            }
        },
        // ==============================

        getIssueFilterOptionsFunc() {
            const data = getIssueFilterOptions.data
            this.formatFilterOptions(data.getIssueFilterOptions)
            this.issueFilterOptions = data.getIssueFilterOptions
        },
        getProjectLocations() {
            const data = this.getProjectLocation.data
            let { floorplans } = data.getProject
            if (data.getProject.map) {
                floorplans = []
                floorplans = [data.getProject.map, ...data.getProject.floorplans]
                data.getProject.map.sectors.forEach((sector) => {
                    sector.floorplans.forEach((fp) => {
                        floorplans.push({ ...fp })
                    })
                })
            }
            this.floorplans = floorplans
        },
        handleListHeightChange() {
            let listEl = this.$refs['list-element']
            let warningsEl = this.$refs['warnings-element']
            let filtersBoxEls = document.getElementsByClassName('filters-box')
            setTimeout(() => {
                if (warningsEl) {
                    let warningsHeight = warningsEl.clientHeight
                    listEl.setAttribute('style', 'height: calc(100% - 64px - ' + warningsHeight + 'px) !important')
                    filtersBoxEls.forEach((element) => {
                        element.setAttribute('style', element.getAttribute('style') + '; top: -' + warningsHeight + 'px')
                    })
                }
            }, 0)
        },
        formatFilterOptions(issueFilterOptions) {
            let typeId = 0
            issueFilterOptions.types.forEach((type) => {
                typeId++
                this.typesOptions.push({
                    id: typeId + '-root',
                    label: type.name,
                    children: type.options.map((op) => ({ id: op.id, label: op.name })),
                })
            })

            let causeId = 0
            issueFilterOptions.causes.forEach((cause) => {
                causeId++
                this.causesOptions.push({
                    id: causeId + '-root',
                    label: cause.name,
                    children: cause.options.map((op) => ({ id: op.id, label: op.name })),
                })
            })

            this.subjectsOptions = issueFilterOptions.subjects.map((subject) => {
                return {
                    id: subject.id,
                    label: subject.code + '-' + subject.name,
                }
            })

            this.locationsOptions = issueFilterOptions.locations.map((location) => {
                return {
                    id: `floorplan-${location.id}`,
                    label: location.name ? location.name : this.$t('map'),
                    children: location.options.map((opt) => {
                        return {
                            id: `viewpoint-${location.id}-${opt.id}`,
                            label: opt.name,
                        }
                    }),
                }
            })

            this.responsiblesOptions = issueFilterOptions.tags.map((group) => {
                return {
                    id: 'group' + group.id,
                    label: group.name ? group.name : this.$t('general'),
                    children: group.options.map((member) => {
                        return {
                            id: member.id,
                            label: member.user ? member.user.name + ' ' + member.user.surname : member.email,
                        }
                    }),
                }
            })

            this.createdByOptions = issueFilterOptions.created_by.map((user) => {
                return {
                    id: 'created-by-' + user.id,
                    label: user.name + ' ' + user.surname,
                }
            })
        },

        nextPage($state) {
            this.isLoading = false
            this.$apollo.queries.getIssues.fetchMore({
                variables: {
                    id: Number(this.$route.params.project_id) || Number(this.$route.params.id),
                    limit: this.limit,
                    page: ++this.page,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    let loadedIssues = fetchMoreResult.getProject.issues
                    if (loadedIssues.length < this.limit) {
                        $state.complete()
                    } else {
                        $state.loaded()
                    }

                    previousResult.getProject.issues = previousResult.getProject.issues.concat(loadedIssues)
                    return previousResult
                },
            })
        },

        setupTypeCollapse() {
            if (this.issueFilterOptions && this.issueFilterOptions.types) {
                this.groupByCollapseController.types = []

                this.issueFilterOptions.types.forEach((type) => {
                    type.options.forEach((option) => {
                        let issuesFromThisType = this.issues.filter((issue) => issue.type == option.id)

                        if (!issuesFromThisType.length) {
                            return
                        }

                        this.$set(this.groupByCollapseController.types, this.groupByCollapseController.types.length, {
                            id: option.id,
                            label: option.label,
                            isOpen: true,
                            issues: issuesFromThisType,
                        })
                    })
                })

                this.$set(this.groupByCollapseController.types, this.groupByCollapseController.types.length, {
                    id: -1,
                    label: this.$t('Components_Issues_IssueList_15'),
                    isOpen: true,
                    issues: this.issues.filter((issue) => !issue.type),
                })
            }
        },
        setupCauseCollapse() {
            if (this.issueFilterOptions && this.issueFilterOptions.causes) {
                this.groupByCollapseController.causes = []

                this.issueFilterOptions.causes.forEach((cause) => {
                    cause.options.forEach((option) => {
                        let issuesWithThisCause = this.issues.filter((issue) => issue.cause == option.id)

                        if (!issuesWithThisCause.length) {
                            return
                        }

                        this.$set(this.groupByCollapseController.causes, this.groupByCollapseController.causes.length, {
                            id: option.id,
                            label: option.label,
                            isOpen: true,
                            issues: issuesWithThisCause,
                        })
                    })
                })

                this.$set(this.groupByCollapseController.causes, this.groupByCollapseController.causes.length, {
                    id: -1,
                    label: this.$t('Components_Issues_IssueList_16'),
                    isOpen: true,
                    issues: this.issues.filter((issue) => !issue.cause),
                })
            }
        },
        setupLocationCollapse() {
            this.groupByCollapseController.locations = []
            if (this.project.map) {
                // floorplans
                if (this.groupByLocationType == 0) {
                    this.groupByCollapseController.locations = []
                    this.project.map.sectors.forEach((sct) => {
                        sct.floorplans.forEach((fp) => {
                            let issuesInThisFloorplan = this.issues.filter((issue) => issue.floorplan && issue.floorplan.id == fp.id)

                            if (issuesInThisFloorplan.length) {
                                this.$set(this.groupByCollapseController.locations, this.groupByCollapseController.locations.length, {
                                    id: fp.id,
                                    label: fp.name,
                                    isOpen: true,
                                    issues: issuesInThisFloorplan,
                                })
                            }
                        })
                    })

                    this.project.floorplans.forEach((fp) => {
                        let issuesInThisFloorplan = this.issues.filter((issue) => issue.floorplan && issue.floorplan.id == fp.id)

                        if (issuesInThisFloorplan.length) {
                            this.$set(this.groupByCollapseController.locations, this.groupByCollapseController.locations.length, {
                                id: fp.id,
                                label: fp.name,
                                isOpen: true,
                                issues: issuesInThisFloorplan,
                            })
                        }
                    })
                    let issuesWithoutFloorplan = this.issues.filter((issue) => !issue.floorplan)

                    if (issuesWithoutFloorplan.length) {
                        this.$set(this.groupByCollapseController.locations, this.groupByCollapseController.locations.length, {
                            id: -1,
                            label: this.$t('Components_Issues_IssueList_17'),
                            isOpen: true,
                            issues: issuesWithoutFloorplan,
                        })
                    }
                }
                // sectors
                else {
                    this.groupByCollapseController.locations = []
                    this.project.map.sectors.forEach((sct) => {
                        let issuesInThisSector = this.issues.filter((issue) => issue.sector && issue.sector.id == sct.id)

                        if (issuesInThisSector.length) {
                            this.$set(this.groupByCollapseController.locations, this.groupByCollapseController.locations.length, {
                                id: sct.id,
                                label: sct.name,
                                isOpen: true,
                                issues: issuesInThisSector,
                            })
                        }
                    })

                    let issuesWithoutSector = this.issues.filter((issue) => !issue.sector)

                    if (issuesWithoutSector.length) {
                        this.$set(this.groupByCollapseController.locations, this.groupByCollapseController.locations.length, {
                            id: -1,
                            label: this.$t('Components_Issues_IssueList_18'),
                            isOpen: true,
                            issues: issuesWithoutSector,
                        })
                    }
                }
            } else {
                if (this.project.floorplans) {
                    this.project.floorplans.forEach((fp) => {
                        let issuesInThisFloorplan = this.issues.filter((issue) => issue.floorplan && issue.floorplan.id == fp.id)

                        if (issuesInThisFloorplan.length) {
                            this.$set(this.groupByCollapseController.locations, this.groupByCollapseController.locations.length, {
                                id: fp.id,
                                label: fp.name,
                                isOpen: true,
                                issues: issuesInThisFloorplan,
                            })
                        }
                    })
                }
            }
        },
        toggleFilterOptions() {
            this.isFilterBoxOpen = !this.isFilterBoxOpen
            if (this.isFilterBoxOpen) {
                setTimeout(() => {}, 1)
            } else {
                this.generateFilterOptions()
            }
        },
        togglePriority(priority) {
            let index = this.selectedPriorities.indexOf(priority)

            if (this.selectedPriorities.includes(priority)) {
                this.selectedPriorities.splice(index, 1)
            } else {
                this.selectedPriorities.push(priority)
            }
        },
        closeFilterOptions() {
            this.isFilterBoxOpen = false
        },
        changeOrder(option) {
            clearTimeout(this.changeOrderByTimer)

            switch (option.value) {
                case 'priority':
                    this.orderByFilter = 0
                    break
                case 'created_at':
                    this.orderByFilter = 1
                    break
                case 'updated_at':
                    this.orderByFilter = 2
                    break
            }

            this.changeOrderByTimer = setTimeout(() => {
                this.generateFilterOptions()
            }, 500)
        },
        generateOrder() {
            this.selectedHeaderOption = null

            this.issueOrder = {
                field: this.orderByOptions[this.orderByFilter].value,
                asc: this.sortByFilter,
            }
            this.issues = []
            this.$emit('issueFilterUpdated', this.issueFilter, this.issueOrder)
            // this.$apollo.queries.getIssues.refetch()
            this.getIssues(this.status)
        },
        generateFilterOptions(reset = false) {
            this.selectedHeaderOption = null

            this.issueFilter = {
                responsibles: this.generateResponsiblesRequest(),
                created_by: this.generateCreatedByRequest(),
                locations: this.generateLocationsRequest(),
                subjects: this.selectedSubjects,
                types: this.selectedTypes,
                causes: this.selectedCauses,
                priorities: this.selectedPriorities,
                created_start: this.createDates.init,
                created_end: this.createDates.end,
                closed_start: this.finishDates.init,
                closed_end: this.finishDates.end,
                due_date_start: this.dueDates.init,
                due_date_end: this.dueDates.end,
                filterReseted: reset,
            }
            this.isLoading = false
            this.issues = []
            this.$emit('issueFilterUpdated', this.issueFilter, this.issueOrder)
            this.getIssues(this.status)
        },
        resetOrderByFilter() {
            this.sortByFilter = 'desc'
            this.orderByFilter = 1
            this.selectedHeaderOption = null

            this.generateFilterOptions()
        },
        resetGeneralFilters() {
            if (this.theresAFilterActive) {
                this.resetFilters()
                this.generateFilterOptions(true)
            }
        },
        resetFilters() {
            this.selectedHeaderOption = null // Close filters popup
            this.selectedPriorities = []
            this.selectedCauses = []
            this.selectedTypes = []
            this.selectedResponsibles = []
            this.selectedCreatedBy = []
            this.selectedSubjects = []

            // Viewer controls the it's own location filter
            if (this.locationType != 'viewer') {
                this.selectedLocations = []
            }

            this.createDates = {
                init: null,
                end: null,
            }

            this.dueDates = {
                init: null,
                end: null,
            }

            this.finishDates = {
                init: null,
                end: null,
            }
            this.isLoading = false
            this.filterReseted = true

            setTimeout((_) => {
                this.issueFilter = undefined
                this.getIssues(this.statusUniversal)
            }, 1000)
        },
        generateLocationsRequest() {
            let viewpoints = this.selectedLocations.filter((l) => l.split('-')[0] == 'viewpoint').map((l) => Number(l.split('-')[2]))
            let viewpointsFromFloorplan = []
            let ids = this.selectedLocations.filter((l) => l.split('-')[0] == 'floorplan').map((l) => Number(l.split('-')[1]))

            let newIds = ids.map((id) => {
                return this.floorplans.find((floorplan) => floorplan.id == id)
            })

            newIds.forEach((floorplan) => {
                viewpointsFromFloorplan.push(...floorplan.viewpoints.map((vp) => vp.id))
            })

            let result = [...viewpoints, ...viewpointsFromFloorplan]

            if (!result.length && ids.length) {
                result = ids
            }

            return result.length ? result : []
        },
        generateResponsiblesRequest() {
            return this.selectedResponsibles.reduce((ids, responsible) => {
                if (typeof responsible == 'string') {
                    let group = this.responsiblesOptions.find((g) => g.id == responsible)
                    ids.push(...group.children.map((m) => m.id))
                } else {
                    ids.push(responsible)
                }
                return ids
            }, [])
        },
        generateCreatedByRequest() {
            return this.selectedCreatedBy.map((id) => {
                return Number(id.replace('created-by-', ''))
            })
        },
        stripDate(date) {
            let strippedNumber = ''
            for (let i = 0; i < date.length; i++) {
                let char = date.charAt(i)
                if (!isNaN(char) && char != ' ') strippedNumber += char
            }
            return strippedNumber
        },
        dateMask(date) {
            let newDate = this.stripDate(date)
            if (newDate.length > 8) newDate = newDate.substr(0, 8)
            if (newDate.length > 2) {
                newDate = `${newDate.substr(0, 2)}/${newDate.substr(2)}`
            }
            if (newDate.length > 5) {
                newDate = `${newDate.substr(0, 5)}/${newDate.substr(5)}`
            }
            return newDate
        },

        // PUBLIC METHODS
        updateList() {
            this.$apollo.queries.getIssues.refetch()
        },
        onIssueDeleted(id) {
            this.$emit('setSelectedIssue', -1)
            this.isLoading = false
            this.issues = []
            this.$apollo.queries.getIssues.refetch()
        },
        onStatusChange() {
            this.isLoading = false
            this.issues = []
            this.$apollo.queries.getIssues.refetch()
        },
    },
    mounted() {
        this.getProjectLocations()
        this.getIssueFilterOptionsFunc()
        this.getIssues()
        window.addEventListener('resize', () => {
            this.handleListHeightChange()
        })
    },
}
</script>

<style lang="scss" scoped>
#issues-list {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.inside-viewer {
        position: relative;

        & > .header {
            background-color: var(--primary-3);
        }

        .filters-box.general-filters {
            height: 80% !important;
        }

        .list {
            height: calc(100% - 80px) !important;
        }
    }

    & > .header .warnings {
        padding: 6px 16px;
    }

    & > .header > .grid {
        padding: 16px;
        padding-bottom: 15px;
        border-bottom: 1px solid var(--primary-2);
        display: grid;
        grid-template-columns: 1fr 32px 32px 32px;
        column-gap: 8px;
        align-items: center;

        .search-input {
            height: 24px;
            display: grid;
            grid-template-columns: 32px 1fr;
            align-items: center;
            background: var(--primary-2);
            border-radius: 4px;

            .icon {
                height: 24px;
            }

            input {
                height: 24px;
                background: transparent;
                border: 0px;
                font-size: 10px;
                // color: var(--secondary-3);
                color: white;
                outline: 0px;
                padding-right: 8px;
            }
        }

        .header-btn-container {
            height: 32px;

            .header-btn {
                display: flex;
                justify-content: center;
                padding-top: 10px;
                background: var(--primary-3);
                border: 1px solid var(--primary-2);
                border-radius: 4px;
                height: 32px;
                cursor: pointer;

                &.enabled {
                    background-color: var(--secondary);
                }

                &.header-btn-active {
                    background: var(--primary-3);
                    height: 49px;
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;
                    border-bottom: 0px;
                }
            }
        }

        .filters-container {
            position: relative;
        }

        .filter-btn {
            position: relative;
            background: var(--primary-2);
            outline: none;
            border-radius: 4px;
            border: 0px;
            color: white;
            height: 40px;
            text-align: left;
            padding: 8px;
            line-height: 20px;
            @media (max-width: 1200px) {
                height: 32px;
                line-height: 16px;
            }

            &.filter-btn-active {
                margin: -1px;
                border: 1px solid var(--secondary);
            }

            .filter-dropdown {
                z-index: 2;
                position: absolute;
                top: calc(100% + 8px);
                left: 0;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.45);

                & > :first-child {
                    border-radius: 4px 4px 0 0;
                }

                & > :last-child {
                    border-radius: 0 0 4px 4px;
                }

                .dropdown-option {
                    background-color: var(--primary-3);
                    padding: 0 8px;
                    height: 40px;

                    &:hover {
                        background-color: var(--primary);
                    }

                    &.active {
                        background-color: var(--accent-dark);
                    }
                }
            }
        }
    }

    .list {
        height: calc(100% - 64px);
        position: relative;

        .filters-box {
            -webkit-box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.5);
            -moz-box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.5);
            box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.5);
            outline: none;
            position: absolute;
            background: var(--primary-3);
            z-index: 1;
            width: 100%;
            display: grid;
            grid-template-rows: 1fr min-content;
            overflow-y: hidden;
            border-radius: 0 0 8px 8px;

            .filters-box-body {
                background: inherit;
                padding: 16px;
                border-radius: 8px 8px 0 0;
                overflow-y: auto;

                .dates-container {
                    background: var(--primary-3);
                }
            }

            .priority-filters {
                display: flex;
                justify-content: space-between;

                .priority-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: calc(100% / 3.5);
                    height: 24px;
                    border-radius: 2px;
                    cursor: pointer;
                    user-select: none;

                    p {
                        color: var(--tertiary-1);
                    }

                    &.active {
                        p {
                            color: white;
                        }

                        &.high {
                            background: var(--semantic-red);
                        }

                        &.medium {
                            background: var(--semantic-yellow);
                        }

                        &.low {
                            background: var(--secondary);
                        }
                    }

                    &.high {
                        background: var(--semantic-red-dark);
                    }

                    &.medium {
                        background: var(--semantic-yellow-dark);
                    }

                    &.low {
                        background: var(--accent-dark);
                    }
                }
            }

            .filters-box-footer {
                height: 39px;
                border-top: 1px solid var(--primary-1);
                display: grid;
                grid-template-columns: 1fr 1fr;
                border-radius: 0 0 8px 8px;

                .reset-btn {
                    cursor: pointer;
                    border-right: 1px solid var(--primary-1);
                }

                .action-btn {
                    cursor: pointer;
                }
            }
        }

        .list-issues-scroll-container {
            width: 100%;
            background-color: var(--primary-2);

            .group-by-container {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .collapse-container {
                    margin-bottom: 8px;

                    .header {
                        display: flex;
                        flex-direction: column;
                        padding: 8px 16px;
                        background-color: var(--primary-3);

                        .header-body {
                            display: flex;
                            align-items: center;
                            padding: 8px 0;
                            border-bottom: 1px solid var(--secondary-1);
                            cursor: pointer;

                            &:hover {
                                p {
                                    opacity: 0.6;
                                    transition: all 0.3s;
                                }
                            }

                            p {
                                margin-left: 8px;
                                opacity: 1;
                                transition: all 0.3s;

                                b {
                                    color: var(--secondary-3);
                                }
                            }
                        }
                    }

                    .content {
                    }
                }
            }

            .item-separator {
                height: 1px;
                width: 100%;
                padding: 0px 16px;

                .bar {
                    background: var(--primary-2);
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>
